import styled, { createGlobalStyle } from "styled-components";

// Farby, pisma a rozmery pre telefon.
//
// Branding je ten isty ako na pneusystem.sk a na rezervacnom portali:
// cervena #D9001B, cierny text, Bebas Neue na nadpisy, DM Sans na text.
// Povodne tu bola fialova zo sablony administracie, co s Pneusystemom
// nemalo nic spolocne.
//
// Rozmery su pre palec, nie pre mys: nic klikacie nema mat menej ako 44px,
// pismo nejde pod 15px, lebo iOS pri mensom pisme v policku sam priblizi
// stranku a clovek potom nevidi, kam pise.
export const F = {
  hlavna: "#D9001B",
  hlavnaTmava: "#A50014",
  text: "#111111",
  textSlaby: "#666666",
  ciara: "#E5E5E5",
  ciaraSlaba: "#EFEFEF",
  pozadie: "#F5F5F5",
  biela: "#FFFFFF",
  jemne: "#FAFAFA",
  zelena: "#1B8A3F",
  oranzova: "#8A5A00",
  oranzovaJemna: "#FFF4CC",
  cervena: "#D9001B",
  modra: "#1F5FA8",
};

// Nadpisy a cisla. Bebas je verzalkove pismo, mensie pismena v nom vyzeraju
// ako kapitalky, preto vsade, kde ho pouzivame, pisme aj text verzalkami.
export const PISMO_NADPIS = "'Bebas Neue', 'DM Sans', Impact, sans-serif";
export const PISMO = "'DM Sans', system-ui, -apple-system, sans-serif";

export const VYSKA_HLAVICKY = 56;
export const VYSKA_MENU = 60;

// Na testovacej adrese ide nad hlavicku tenky pruh, aby nikto neplietol
// test s ostrym. Je sucastou appky, nie nalepka od serveru: dve lepiace
// listy nad sebou si na iPhone navzajom liezu do notchu.
export const jeTest = () =>
  typeof window !== "undefined" && /^test\./i.test(window.location.hostname);

export const VYSKA_TESTU = jeTest() ? 22 : 0;

// Vyska vsetkeho, co sa lepi hore. Pouziva ju hlavicka aj odsadenie obsahu,
// takze sa to neda rozjst.
export const HORE = `calc(${VYSKA_HLAVICKY + VYSKA_TESTU}px + env(safe-area-inset-top, 0px))`;

// Celoobrazovkovy rezim na iPhone nekonci na hrane skla, pod menu je este
// ciarka na zatvorenie aplikacie. safe-area-inset-bottom je presne tolko,
// kolko si ten pruh berie, na Androide je nula.
//
// Pisma su ulozene u nas, nie z Google Fonts. V telefone na dvore casto nie
// je signal a stiahnutie z cudzej adresy by service worker nepodchytil,
// takze by sa aplikacia zobrazila nahradnym pismom.
export const GlobalneMobil = createGlobalStyle`
  @font-face {
    font-family: 'Bebas Neue';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(/pismo/bebas-neue-latin-ext.woff2) format('woff2');
    unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7,
      U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
      U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F,
      U+A720-A7FF;
  }
  @font-face {
    font-family: 'Bebas Neue';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(/pismo/bebas-neue-latin.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6,
      U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
      U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 300 700;
    font-display: swap;
    src: url(/pismo/dm-sans-latin-ext.woff2) format('woff2');
    unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7,
      U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F,
      U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F,
      U+A720-A7FF;
  }
  @font-face {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 300 700;
    font-display: swap;
    src: url(/pismo/dm-sans-latin.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6,
      U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122,
      U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  html, body {
    background: ${F.pozadie};
    overscroll-behavior-y: none;
  }
  body {
    font-family: ${PISMO};
    -webkit-tap-highlight-color: transparent;
  }
`;

export const Obal = styled.div`
  min-height: 100vh;
  background: ${F.pozadie};
  color: ${F.text};
  font-family: ${PISMO};
  font-size: 15px;
  line-height: 1.45;
  /* Hlavicka je lepena a na iPhone je o notch vyssia. Keby sa tu ratalo
     len s ${VYSKA_HLAVICKY}px, prvy riadok obsahu by na novsich iPhonoch
     zmizol pod nou. Presne to sa stalo pri prvom teste. */
  padding-top: ${HORE};
  padding-bottom: calc(${VYSKA_MENU}px + env(safe-area-inset-bottom, 0px) + 12px);
  -webkit-font-smoothing: antialiased;
`;

export const Plocha = styled.div`
  padding: 12px 12px 0;
`;

export const Karta = styled.div`
  background: ${F.biela};
  border: 1px solid ${F.ciara};
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 10px;
  display: block;
  text-decoration: none;

  /* antd farbí odkazy pri dotyku svojou modrou. Na telefóne hover po
     ťuknutí ostáva visieť, kým človek neťukne inam, takže by karta po
     návrate z detailu svietila namodro. && pretlačí vlastnú farbu. */
  && {
    color: inherit;
  }

  &:active {
    background: ${F.jemne};
  }
`;

export const RiadokKarty = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;

// SPZ je to prve, co clovek na karte hlada, preto nadpisovym pismom.
export const Spz = styled.div`
  font-family: ${PISMO_NADPIS};
  font-weight: 400;
  font-size: 23px;
  line-height: 1.05;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

export const Drobne = styled.div`
  font-size: 13px;
  color: ${F.textSlaby};
  margin-top: 3px;
  overflow-wrap: anywhere;
`;

export const Prazdne = styled.div`
  text-align: center;
  color: ${F.textSlaby};
  padding: 48px 20px;
  font-size: 15px;
`;

export const NadpisSkupiny = styled.div`
  font-family: ${PISMO_NADPIS};
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${F.text};
  margin: 18px 2px 8px;

  &:first-child {
    margin-top: 2px;
  }
`;
